import { Tooltip } from 'bootstrap';

export function initTooltips(root: ParentNode = document): void {
    root.querySelectorAll<HTMLElement>('[data-bs-toggle="tooltip"]').forEach((el) => {
        if (!Tooltip.getInstance(el)) {
            new Tooltip(el);
        }
    });
}
